// extracted by mini-css-extract-plugin
module.exports = {"checkableTag":"CheckboxTag_style_checkableTag__238tT"};